<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="my-4">
                <div class="mt-2 w-full">
                    <label class="text-xs w-full mb-1" for="name">Name *</label>
                    <input type="text" name="name" id="name" formControlName="name" placeholder="Name"
                        class="rounded w-full my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                    <div
                        class="{{ form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-3 text-red-500 text-xs">
                        @if (form.get('name')?.errors?.['required']) {
                        <p>
                            Value is required
                        </p>
                        } @else if(form.get('name')?.errors?.['minlength'] ||
                        form.get('name')?.errors?.['maxlength']) {
                        <p>
                            Min 3 and max 150 characters required
                        </p>
                        }
                    </div>
                </div>
            </div>
            <div class="flex flex-row gap-4 justify-end">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <app-btn-submit [isLoading]="working" [actionText]="action"
                    bgColor="bg-primary-500 active:btn-secondary-500 hover:bg-primary-300 disabled:bg-primary-200"
                    [isDisabled]="form.invalid"></app-btn-submit>
            </div>
        </form>
    </div>
</div>